import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d8c370da"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-header-card" }, "Results", -1))
const _hoisted_2 = { class: "info d-flex justify-start" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-no-wrap" }, "Campaign Info", -1))
const _hoisted_4 = { class: "d-flex align-center justify-center w-100" }
const _hoisted_5 = {
  key: 0,
  class: "ml-4"
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " Copy Success ", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { style: {"border-color":"#ffffff","margin-top":"10px"} }, null, -1))
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "d-flex justify-center mt-11" }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "d-flex justify-center mt-11" }
const _hoisted_15 = {
  key: 1,
  class: "pt-5"
}
const _hoisted_16 = { style: {"width":"100%","height":"30rem","position":"relative"} }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "error" }, [
  /*#__PURE__*/_createElementVNode("p", {
    class: "font-weight-bold",
    style: {"font-size":"1rem"}
  }, "Error Found")
], -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = { key: 2 }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex justify-center align-center text-center",
  style: {"padding-top":"15rem"}
}, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-weight-bold" }, "No data yet. let's go get some customers! 😁💵")
], -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = {
  key: 4,
  class: "container-result-table-dashboard-info"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_26 = { class: "wmx-200" }
const _hoisted_27 = { class: "filter" }
const _hoisted_28 = ["src"]
const _hoisted_29 = {
  class: "filter",
  style: {"justify-content":"end"}
}
const _hoisted_30 = ["src"]
const _hoisted_31 = {
  class: "filter",
  style: {"justify-content":"end"}
}
const _hoisted_32 = ["src"]
const _hoisted_33 = {
  class: "filter",
  style: {"justify-content":"end"}
}
const _hoisted_34 = ["src"]
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { class: "text-center" }
const _hoisted_37 = { class: "text-end" }
const _hoisted_38 = { class: "text-end" }
const _hoisted_39 = { class: "text-end" }
const _hoisted_40 = { style: {"padding-right":"30px"} }
const _hoisted_41 = {
  key: 0,
  class: "d-flex justify-center"
}
const _hoisted_42 = { class: "d-flex justify-center align-center" }
const _hoisted_43 = {
  key: 1,
  class: "d-flex justify-center align-center text-center"
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "d-flex justify-center align-center" }, [
  /*#__PURE__*/_createElementVNode("p", {
    class: "font-weight-bold py-4",
    style: {"font-size":"1rem"}
  }, "No Data")
], -1))
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = {
  key: 2,
  class: "d-flex justify-center align-center text-center"
}
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "d-flex justify-center align-center" }, [
  /*#__PURE__*/_createElementVNode("p", {
    class: "font-weight-bold",
    style: {"font-size":"1rem"}
  }, "Error Found")
], -1))
const _hoisted_48 = [
  _hoisted_47
]
const _hoisted_49 = { key: 5 }
const _hoisted_50 = { class: "container-result-table-activity-logs" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_52 = { class: "wmx-210" }
const _hoisted_53 = { class: "filter" }
const _hoisted_54 = ["src"]
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "wmx-150" }, "User ID", -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "wmx-150" }, "Merchant ID", -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "wmx-150" }, "Merchant Code", -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "wmx-150" }, "Merchant Name", -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "wmx-210",
  style: {"text-align":"start"}
}, "Description", -1))
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "wmx-100" }, "Commission", -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "wmx-210",
  style: {"text-align":"end"}
}, "Reward (THB)", -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "wmx-150" }, "Status", -1))
const _hoisted_63 = { key: 0 }
const _hoisted_64 = { class: "text-center" }
const _hoisted_65 = { class: "text-center" }
const _hoisted_66 = { class: "text-center" }
const _hoisted_67 = { class: "text-center" }
const _hoisted_68 = { class: "text-center" }
const _hoisted_69 = { class: "text-left" }
const _hoisted_70 = { key: 0 }
const _hoisted_71 = { key: 1 }
const _hoisted_72 = { key: 2 }
const _hoisted_73 = { key: 3 }
const _hoisted_74 = { key: 4 }
const _hoisted_75 = { key: 5 }
const _hoisted_76 = { key: 0 }
const _hoisted_77 = { key: 0 }
const _hoisted_78 = { key: 1 }
const _hoisted_79 = { style: {"text-align":"end"} }
const _hoisted_80 = { class: "text-center" }
const _hoisted_81 = {
  key: 0,
  class: "container-status"
}
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "15",
  height: "15",
  viewBox: "0 0 10 11",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "5",
    cy: "5.5",
    r: "5",
    fill: "#3297FF"
  })
], -1))
const _hoisted_83 = {
  key: 1,
  class: "container-status"
}
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "15",
  height: "15",
  viewBox: "0 0 10 11",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "5",
    cy: "5.5",
    r: "4",
    fill: "white",
    stroke: "#FF9E40",
    "stroke-width": "2"
  })
], -1))
const _hoisted_85 = {
  key: 2,
  class: "container-status"
}
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "15",
  height: "15",
  viewBox: "0 0 10 11",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "5",
    cy: "5.5",
    r: "5",
    fill: "#FF9E40"
  })
], -1))
const _hoisted_87 = {
  key: 3,
  class: "container-status"
}
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "15",
  height: "15",
  viewBox: "0 0 10 11",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "5",
    cy: "5.5",
    r: "5",
    fill: "#43BF76"
  })
], -1))
const _hoisted_89 = {
  key: 4,
  class: "container-status"
}
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "15",
  height: "15",
  viewBox: "0 0 10 11",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "5",
    cy: "5.5",
    r: "5",
    fill: "#F1502F"
  })
], -1))
const _hoisted_91 = {
  key: 5,
  class: "container-status"
}
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "15",
  height: "15",
  viewBox: "0 0 10 11",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "5",
    cy: "5.5",
    r: "5",
    fill: "#9D9EB1"
  })
], -1))
const _hoisted_93 = {
  key: 6,
  class: "text-start"
}
const _hoisted_94 = {
  key: 0,
  class: "d-flex justify-center"
}
const _hoisted_95 = { class: "d-flex justify-center align-center" }
const _hoisted_96 = {
  key: 1,
  class: "d-flex justify-center align-center text-center"
}
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "d-flex justify-center align-center" }, [
  /*#__PURE__*/_createElementVNode("p", {
    class: "font-weight-bold py-4",
    style: {"font-size":"1rem"}
  }, "No Data")
], -1))
const _hoisted_98 = [
  _hoisted_97
]
const _hoisted_99 = {
  key: 2,
  class: "d-flex justify-center align-center text-center"
}
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "d-flex justify-center align-center" }, [
  /*#__PURE__*/_createElementVNode("p", {
    class: "font-weight-bold",
    style: {"font-size":"1rem"}
  }, "Error Found")
], -1))
const _hoisted_101 = [
  _hoisted_100
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ResultDropdown = _resolveComponent("ResultDropdown")!
  const _component_VLoading = _resolveComponent("VLoading")!
  const _component_VButton = _resolveComponent("VButton")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!
  const _component_CInfo = _resolveComponent("CInfo")!
  const _component_CardInfoComponents = _resolveComponent("CardInfoComponents")!
  const _component_CCondition = _resolveComponent("CCondition")!
  const _component_Card = _resolveComponent("Card")!
  const _component_VTab = _resolveComponent("VTab")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_CardItemComponents = _resolveComponent("CardItemComponents")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_ChartComponent = _resolveComponent("ChartComponent")!
  const _component_InputCheckBox = _resolveComponent("InputCheckBox")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_MerchantListTable = _resolveComponent("MerchantListTable")!
  const _component_UserListTable = _resolveComponent("UserListTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Card, null, {
      header: _withCtx(() => [
        _hoisted_1
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.getWindowsSize['x'] < 600 ? 'pl-3 pr-3' : '')
        }, [
          _createElementVNode("div", null, [
            _createVNode(_component_ResultDropdown, {
              msg: 'Campaign Name',
              "campaign-change": _ctx.campaignSelected,
              data: _ctx.campaignDropdown,
              width: _ctx.getWindowsSize['x'] < 1300 ? '100%' : '40rem',
              "partner-code": _ctx.user?.partnerCode,
              onCampaignSelected: _cache[0] || (_cache[0] = ($event: any) => (_ctx.campaignSelected = $event))
            }, null, 8, ["campaign-change", "data", "width", "partner-code"])
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.getWindowsSize['x'] < 800 ? 'pt-10' : 'flex-m pt-10')
          }, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_4, [
                  (_ctx.campaignInfo?.isActive === undefined)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createVNode(_component_VLoading, {
                          color: '#3B3C66',
                          width: 3,
                          size: 20
                        })
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createElementVNode("img", {
                          src: _ctx.getCampaignStatusIcon(_ctx.campaignInfo?.isActive),
                          alt: "status",
                          style: {"width":"50px","height":"50px"}
                        }, null, 8, _hoisted_7)
                      ]))
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "flex-m",
              style: _normalizeStyle(_ctx.getWindowsSize['x'] < 800 ? 'padding-top: 5px' : 'justify-content: end;')
            }, [
              _createVNode(_component_VButton, {
                message: 'Open',
                radius: '20px',
                bgBorder: '1px solid #dadbe6',
                width: '7rem',
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openLinkInNewTab())),
                isDisable: _ctx.isNoCampaign,
                src: require('@/assets/svgs/icons/link.svg')
              }, null, 8, ["isDisable", "src"]),
              _createVNode(_component_VButton, {
                message: 'Copy',
                radius: '20px',
                bgColor: '#3297FF',
                fontColor: 'white',
                width: '7rem',
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.copyToClipboard())),
                isDisable: _ctx.isNoCampaign,
                src: require('@/assets/svgs/icons/copy.svg')
              }, null, 8, ["isDisable", "src"]),
              _createVNode(_component_v_snackbar, {
                modelValue: _ctx.snackbar,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.snackbar) = $event))
              }, {
                actions: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    variant: "text",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.snackbar = false))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Close ")
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              }, 8, ["modelValue"])
            ], 4)
          ], 2),
          _hoisted_9,
          _createElementVNode("div", {
            style: _normalizeStyle(_ctx.getWindowsSize['x'] < 600 ? 'display: gird ; padding-top: 10px' : 'display: flex ; padding-top: 20px')
          }, [
            _createVNode(_component_CardInfoComponents, {
              height: '100%',
              width: '100%',
              textAlign: 'left',
              background: '#fff'
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  (_ctx.isCampaignInfoEmpty)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _createVNode(_component_VLoading, {
                            color: '#3B3C66',
                            width: 3,
                            size: 50
                          })
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _createVNode(_component_CInfo, { campaignInfo: _ctx.campaignInfo }, null, 8, ["campaignInfo"])
                      ]))
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_CardInfoComponents, {
              height: '100%',
              width: '100%',
              textAlign: 'left',
              background: '#F5F5F7'
            }, {
              default: _withCtx(() => [
                (_ctx.isCampaignConditionEmpty)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createVNode(_component_VLoading, {
                          color: '#3B3C66',
                          width: 3,
                          size: 50
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.campaignCondition?.type !== undefined && _ctx.isCampaignConditionEmpty !== true)
                  ? (_openBlock(), _createBlock(_component_CCondition, {
                      key: 1,
                      type: _ctx.campaignCondition?.type,
                      data: _ctx.campaignCondition,
                      isLoading: _ctx.isCampaignConditionEmpty
                    }, null, 8, ["type", "data", "isLoading"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ], 4)
        ], 2)
      ]),
      _: 1
    }),
    _createVNode(_component_Card, {
      style: {"margin":"2rem 0"},
      class: _normalizeClass(_ctx.getWindowsSize['x'] < 600 ? 'pl-3 pr-3' : '')
    }, {
      default: _withCtx(() => [
        _createVNode(_component_VTab, {
          data: _ctx.tabResult,
          onMenu: _cache[5] || (_cache[5] = ($event: any) => (_ctx.tabActive = $event))
        }, null, 8, ["data"]),
        (_ctx.tabActive === _ctx.RESULT_TABS.DASHBOARD || _ctx.tabActive === _ctx.RESULT_TABS.ACTIVITY_LOG)
          ? (_openBlock(), _createBlock(_component_v_col, {
              key: 0,
              class: "pa-0 mt-10 col"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DatePicker, {
                  label: 'From Date - To Date',
                  width: _ctx.getWindowsSize['x'] < 1100 ? '100%' : '100%',
                  widthContent: _ctx.getWindowsSize['x'] < 1100 ? '100%' : '40rem',
                  disable: _ctx.dashboardInfo.length > 0,
                  onSearch: _ctx.onSearch,
                  "start-date": _ctx.tabActive === _ctx.RESULT_TABS.DASHBOARD ? _ctx.dashboardSummaryForm.startDate : _ctx.activityLogsForm.startDate,
                  "end-date": _ctx.tabActive === _ctx.RESULT_TABS.DASHBOARD ? _ctx.dashboardSummaryForm.endDate : _ctx.activityLogsForm.endDate
                }, null, 8, ["width", "widthContent", "disable", "onSearch", "start-date", "end-date"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.tabActive === _ctx.RESULT_TABS.DASHBOARD)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createVNode(_component_v_row, {
                style: _normalizeStyle(_ctx.getWindowsSize['x'] < 600 ? 'display: grid; margin: 0; gap: 20px' : 'margin: 0 ; gap: 20px')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { class: "pa-0" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CardItemComponents, {
                        label: 'Register',
                        width: '100%',
                        "color-font": '#6C6DF2',
                        value: _ctx.isDashboardSummaryEmpty ? '0' : _ctx.addComma(_ctx.dashboardSummary?.register || '0', { toFixed: 0 }),
                        "font-size": '30px'
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { class: "pa-0" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CardItemComponents, {
                        label: 'Goal Achieved',
                        width: '100%',
                        value: 
              _ctx.isDashboardSummaryEmpty
                ? '0'
                : _ctx.addComma(_ctx.dashboardSummary?.goalAchieved || '0', {
                    toFixed: 0,
                  })
            ,
                        "color-font": '#3DC0CB',
                        "font-size": '30px'
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { class: "pa-0" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CardItemComponents, {
                        label: 'Conversion',
                        width: '100%',
                        "color-font": '#3B3C66',
                        value: 
              _ctx.isDashboardSummaryEmpty
                ? '0 %'
                : _ctx.addComma(_ctx.dashboardSummary?.conversion || '0', {
                    toFixed: 2,
                  }) + ' % '
            ,
                        "font-size": '30px'
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { class: "pa-0" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CardItemComponents, {
                        label: 'Reward',
                        width: '100%',
                        "color-font": '#3297FF',
                        value: 
              _ctx.isDashboardSummaryEmpty
                ? '0 THB'
                : _ctx.addComma(_ctx.dashboardSummary?.reward || '0', {
                    toFixed: 2,
                  }) + ' THB '
            ,
                        "font-size": '30px'
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["style"]),
              (_ctx.getWindowsSize['x'] < 600)
                ? (_openBlock(), _createBlock(_component_v_container, {
                    key: 0,
                    class: "mt-5"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, { class: "sort d-flex justify-center" }, {
                        default: _withCtx(() => [
                          _createElementVNode("button", {
                            class: _normalizeClass(["btn", { active: _ctx.isRegisterMode }]),
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.setChartConfig('is_show_register_line', true)))
                          }, " Register ", 2),
                          _createElementVNode("button", {
                            class: _normalizeClass(["btn", { active: _ctx.isGoalAchievedMode }]),
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.setChartConfig('is_show_goal_line', true)))
                          }, " Goal Achieved ", 2),
                          _createElementVNode("button", {
                            class: _normalizeClass(["btn", { active: _ctx.isRewardMode }]),
                            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.setChartConfig('is_show_bar', true)))
                          }, " Reward ", 2)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.tabActive === _ctx.RESULT_TABS.DASHBOARD)
          ? (_openBlock(), _createBlock(_component_v_container, { key: 2 }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_16, [
                  (_ctx.isLoadingDashboardChart)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _createVNode(_component_v_row, {
                          class: "d-flex justify-center",
                          style: {"padding-top":"15rem"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_VLoading, {
                              color: '#3B3C66',
                              width: 3,
                              size: 50
                            })
                          ]),
                          _: 1
                        })
                      ]))
                    : (_ctx.isErrorDashboardChart)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_20))
                      : (_ctx.isNoDashboardChart)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, _hoisted_23))
                        : (_openBlock(), _createBlock(_component_ChartComponent, {
                            key: 3,
                            config: _ctx.chartConfig
                          }, null, 8, ["config"]))
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.tabActive === _ctx.RESULT_TABS.DASHBOARD || _ctx.tabActive === _ctx.RESULT_TABS.ACTIVITY_LOG)
          ? (_openBlock(), _createElementBlock("div", {
              key: 3,
              class: _normalizeClass(_ctx.tabActive === _ctx.RESULT_TABS.DASHBOARD ? 'mt-16' : 'mt-4')
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["d-flex align-items-center", _ctx.tabActive === _ctx.RESULT_TABS.DASHBOARD ? 'justify-space-between' : 'justify-end'])
              }, [
                (_ctx.tabActive === _ctx.RESULT_TABS.DASHBOARD)
                  ? (_openBlock(), _createBlock(_component_InputCheckBox, {
                      key: 0,
                      label: "แสดงเฉพาะวันที่ที่มีข้อมูลเท่านั้น",
                      "sync-data": _ctx.showOnlyDateWithData,
                      onChecked: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showOnlyDateWithData = true)),
                      onUnChecked: _cache[10] || (_cache[10] = ($event: any) => (_ctx.showOnlyDateWithData = false))
                    }, null, 8, ["sync-data"]))
                  : _createCommentVNode("", true),
                (_ctx.tabActive === _ctx.RESULT_TABS.ACTIVITY_LOG)
                  ? (_openBlock(), _createBlock(_component_VButton, {
                      key: 1,
                      message: 'Export',
                      radius: '20px',
                      bgBorder: '1px solid #dadbe6',
                      width: '10rem',
                      isDisable: _ctx.isNoCampaign,
                      src: require('@/assets/svgs/icons/csv.svg'),
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.DoExportExcelResult()))
                    }, null, 8, ["isDisable", "src"]))
                  : _createCommentVNode("", true)
              ], 2)
            ], 2))
          : _createCommentVNode("", true),
        (_ctx.tabActive === _ctx.RESULT_TABS.DASHBOARD)
          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
              _createElementVNode("table", null, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _hoisted_25,
                    _createElementVNode("th", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        _createTextVNode(" Date "),
                        _createElementVNode("img", {
                          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.dashboardInfo.length > 0 ? _ctx.sortDate() : '')),
                          src: _ctx.$data[_ctx.sortIconStartDate],
                          alt: "SVG Image"
                        }, null, 8, _hoisted_28)
                      ])
                    ]),
                    _createElementVNode("th", null, [
                      _createElementVNode("div", _hoisted_29, [
                        _createTextVNode(" Register "),
                        _createElementVNode("img", {
                          onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.dashboardInfo.length > 0 ? _ctx.sortRegister() : '')),
                          src: _ctx.$data[_ctx.sortIconRegister],
                          alt: "SVG Image"
                        }, null, 8, _hoisted_30)
                      ])
                    ]),
                    _createElementVNode("th", null, [
                      _createElementVNode("div", _hoisted_31, [
                        _createTextVNode(" Goal Achieved "),
                        _createElementVNode("img", {
                          onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.dashboardInfo.length > 0 ? _ctx.sortGoalAchieved() : '')),
                          src: _ctx.$data[_ctx.sortIconGoalAchieved],
                          alt: "SVG Image"
                        }, null, 8, _hoisted_32)
                      ])
                    ]),
                    _createElementVNode("th", null, [
                      _createElementVNode("div", _hoisted_33, [
                        _createTextVNode(" Reward (THB) "),
                        _createElementVNode("img", {
                          onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.dashboardInfo.length > 0 ? _ctx.sortReward() : '')),
                          src: _ctx.$data[_ctx.sortIconReward],
                          alt: "SVG Image"
                        }, null, 8, _hoisted_34)
                      ])
                    ])
                  ])
                ]),
                (!_ctx.isLoadingDashboard)
                  ? (_openBlock(), _createElementBlock("tbody", _hoisted_35, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dashboardInfo, (item, index) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: index,
                          class: _normalizeClass({ 'line-end': index === _ctx.dashboardInfo.length - 1 })
                        }, [
                          _createElementVNode("td", null, [
                            _createElementVNode("p", null, _toDisplayString(_ctx.numberHeader(index + 1)), 1)
                          ]),
                          _createElementVNode("td", _hoisted_36, [
                            _createElementVNode("p", null, _toDisplayString(_ctx.$dayjs(item.date).format("DD/MM/YYYY") || "-"), 1)
                          ]),
                          _createElementVNode("td", _hoisted_37, [
                            _createElementVNode("p", null, _toDisplayString(_ctx.addComma(item.register || "0")), 1)
                          ]),
                          _createElementVNode("td", _hoisted_38, [
                            _createElementVNode("p", null, _toDisplayString(_ctx.addComma(item.goalAchieved || "0")), 1)
                          ]),
                          _createElementVNode("td", _hoisted_39, [
                            _createElementVNode("p", _hoisted_40, _toDisplayString(_ctx.addComma(item.reward || "0", { toFixed: 2 })), 1)
                          ])
                        ], 2))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", null, [
                (_ctx.isLoadingDashboard)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_41, [
                      _createElementVNode("td", _hoisted_42, [
                        _createVNode(_component_v_progress_circular, {
                          class: "mt-5",
                          color: "#3B3C66",
                          indeterminate: "",
                          width: 3,
                          size: 25
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isNoDataDashboard)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_43, _hoisted_45))
                  : _createCommentVNode("", true),
                (_ctx.isErrorFoundDashboard)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_46, _hoisted_48))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_component_Pagination, {
                class: "pagination",
                justifyContent: _ctx.getWindowsSize['x'] < 600 ? 'center' : 'flex-end',
                data: _ctx.dashboardInfoForm.pagination,
                totalPage: _ctx.paginationDashboardInfo.totalPages,
                onPage: _ctx.pageNow,
                onPerPageEvent: _ctx.changeNumberPerPage,
                onLength: _ctx.changeLength
              }, null, 8, ["justifyContent", "data", "totalPage", "onPage", "onPerPageEvent", "onLength"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.tabActive === _ctx.RESULT_TABS.ACTIVITY_LOG)
          ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("table", null, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _hoisted_51,
                      _createElementVNode("th", _hoisted_52, [
                        _createElementVNode("div", _hoisted_53, [
                          _createTextVNode(" DateTime "),
                          _createElementVNode("img", {
                            onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.sortDateTime())),
                            src: _ctx.$data[_ctx.sortIconDateTime],
                            alt: "SVG Image"
                          }, null, 8, _hoisted_54)
                        ])
                      ]),
                      _hoisted_55,
                      _hoisted_56,
                      _hoisted_57,
                      _hoisted_58,
                      _hoisted_59,
                      _hoisted_60,
                      _hoisted_61,
                      _hoisted_62
                    ])
                  ]),
                  (!_ctx.isLoadingActivityLog)
                    ? (_openBlock(), _createElementBlock("tbody", _hoisted_63, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activityLogs, (item, index) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: index,
                            class: _normalizeClass({ 'line-end': index === _ctx.activityLogs.length - 1 })
                          }, [
                            _createElementVNode("td", null, [
                              _createElementVNode("p", null, _toDisplayString(_ctx.numberHeader(index + 1)), 1)
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("p", _hoisted_64, _toDisplayString(_ctx.onChangeFormatDateTime(item.processingDate)), 1)
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("p", _hoisted_65, _toDisplayString(item.userId || "-"), 1)
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("p", _hoisted_66, _toDisplayString(item.merchantId || "-"), 1)
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("p", _hoisted_67, _toDisplayString(item.merchantCode || "-"), 1)
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("p", _hoisted_68, _toDisplayString(item.merchantName || "-"), 1)
                            ]),
                            _createElementVNode("td", _hoisted_69, [
                              (item.actionType === 'Action_Register')
                                ? (_openBlock(), _createElementBlock("p", _hoisted_70, "Register"))
                                : (item.actionType === 'Action_Payment')
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_71, " Payment: " + _toDisplayString(_ctx.addComma(item.paymentAmount ?? "0", {
                      toFixed: 2,
                    })) + " THB ", 1))
                                  : (item.actionType === 'Action_CreateMerchant')
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_72, "Create Merchant"))
                                    : (item.remark === 'Added')
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_73, "Added"))
                                      : (item.actionType === 'CreateMerchant')
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_74, "User Create Merchant"))
                                        : (_openBlock(), _createElementBlock("p", _hoisted_75, "Register"))
                            ]),
                            _createElementVNode("td", null, [
                              (item.actionType === 'Register' || item.actionType === 'CreateMerchant')
                                ? (_openBlock(), _createElementBlock("p", _hoisted_76, "-"))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    (item.type === 'PERCENT')
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_77, _toDisplayString(_ctx.addComma(item.amountPercent)) + " %", 1))
                                      : (_openBlock(), _createElementBlock("p", _hoisted_78, _toDisplayString(item.amountPerTime) + "/Action", 1))
                                  ], 64))
                            ]),
                            _createElementVNode("td", _hoisted_79, _toDisplayString(_ctx.addComma(item.rewardAmount, { toFixed: 2 })), 1),
                            _createElementVNode("td", _hoisted_80, [
                              (item.status === 'WAIT_FOR_PROCESSING')
                                ? (_openBlock(), _createElementBlock("p", _hoisted_81, [
                                    _hoisted_82,
                                    _createTextVNode(" Wait for processing ")
                                  ]))
                                : (item.status === 'WAIT_FOR_REQUESTING')
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_83, [
                                      _hoisted_84,
                                      _createTextVNode(" Wait for requesting ")
                                    ]))
                                  : (item.status === 'PENDING')
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_85, [
                                        _hoisted_86,
                                        _createTextVNode(" Pending ")
                                      ]))
                                    : (item.status === 'PAID')
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_87, [
                                          _hoisted_88,
                                          _createTextVNode(" Paid ")
                                        ]))
                                      : (item.status === 'EXPIRED')
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_89, [
                                            _hoisted_90,
                                            _createTextVNode(" Expired ")
                                          ]))
                                        : (item.status === 'VOID')
                                          ? (_openBlock(), _createElementBlock("p", _hoisted_91, [
                                              _hoisted_92,
                                              _createTextVNode(" Void ")
                                            ]))
                                          : (_openBlock(), _createElementBlock("p", _hoisted_93, "-"))
                            ])
                          ], 2))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", null, [
                  (_ctx.isLoadingActivityLog)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_94, [
                        _createElementVNode("td", _hoisted_95, [
                          _createVNode(_component_v_progress_circular, {
                            class: "mt-5",
                            color: "#3B3C66",
                            indeterminate: "",
                            width: 3,
                            size: 25
                          })
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isNoDataActivityLogs)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_96, _hoisted_98))
                    : _createCommentVNode("", true),
                  (_ctx.isErrorFoundActivityLogs)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_99, _hoisted_101))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_Pagination, {
                  class: "pagination",
                  justifyContent: _ctx.getWindowsSize['x'] < 600 ? 'center' : 'flex-end',
                  data: _ctx.activityLogsForm.pagination,
                  totalPage: _ctx.paginationActivityLogs.totalPages,
                  onPage: _ctx.pageNow,
                  onPerPageEvent: _ctx.changeNumberPerPage,
                  onLength: _ctx.changeLength
                }, null, 8, ["justifyContent", "data", "totalPage", "onPage", "onPerPageEvent", "onLength"])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.tabActive === _ctx.RESULT_TABS.MERCHANT_LIST)
          ? (_openBlock(), _createBlock(_component_MerchantListTable, {
              key: 6,
              campaignCode: _ctx.campaignSelected
            }, null, 8, ["campaignCode"]))
          : _createCommentVNode("", true),
        (_ctx.tabActive === _ctx.RESULT_TABS.USER_LIST)
          ? (_openBlock(), _createBlock(_component_UserListTable, {
              key: 7,
              campaignCode: _ctx.campaignSelected
            }, null, 8, ["campaignCode"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["class"])
  ], 64))
}